import MarkdownEditor from "@/component/Markdown/MarkdownEditor";
import MarkdownPreview from "@/component/Markdown/MarkdownPreview";
import { SUMMARY_TEXTAREA_ID } from "@/constants/record";
import summaryStore from "@/store/summary.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect } from "react";

const MeetingSummary = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const summary = summaryStore((state) => state.summary);
  const modifySummary = summaryStore((state) => state.modifySummary);
  const newSummary = summaryStore((state) => state.newSummary);

  useEffect(() => {
    if (summaryEditing) {
      const dom = document.getElementById(
        SUMMARY_TEXTAREA_ID
      ) as HTMLTextAreaElement;
      dom?.focus();
      // 光标移到最后
      dom?.setSelectionRange(dom.value.length, dom.value.length);
    }
  }, [summaryEditing]);

  const handleEditContent = (content: string, index: number) => {
    if (!newSummary) return;
    modifySummary({
      ...newSummary,
      meetingSummary: newSummary.meetingSummary.map((item, _index) => {
        if (index === _index) {
          return content;
        }
        return item;
      }),
    });
  };

  return (
    <div className="color-#30343C text-3.5 text-justify font-normal select-text lh-7">
      {summary?.srcAiGcContent?.meetingSummary?.length ?? 0 > 0 ? summary?.srcAiGcContent?.meetingSummary?.map((item, index) =>
        summaryEditing ? (
          <MarkdownEditor
            key={index}
            id={index.toString()}
            mode="wysiwyg"
            initialValue={item}
            onChange={(content) => handleEditContent(content, index)}
          />
        ) : (
          <MarkdownPreview key={index} value={item} />
        )
      ) : (
        <div className="mt-2.5 text-mx-quaternary">暂无概要哦</div>
      )}
    </div>
  );
};

export default MeetingSummary;
